import { render, staticRenderFns } from "./MobileReserveLayout.vue?vue&type=template&id=57d8b1d0&scoped=true&"
import script from "./MobileReserveLayout.vue?vue&type=script&lang=js&"
export * from "./MobileReserveLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d8b1d0",
  null
  
)

export default component.exports